export enum EmbedLinkType {
    Dashboard = 'dashboard',
    Look = 'look',
}

export interface EmbedLink {
    name: string;
    url: string;
    host: string;
    translationKey: string;
    type?: EmbedLinkType;
}
